import { useEffect } from "react";
import { MainLayout } from "@/components/layout/MainLayout";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { CallRecordingsList } from "@/components/recordings/CallRecordingsList";

const RecordingsPage = () => {
  useEffect(() => {
    document.title = 'Recordings | Calie.ai';
  }, []);

  return (
    <MainLayout>
      <div className="space-y-4">
        <h1 className="text-2xl font-bold">Call Recordings</h1>
        <Card>
          <CardHeader>
            <CardTitle>All Recordings</CardTitle>
          </CardHeader>
          <CardContent>
            <CallRecordingsList />
          </CardContent>
        </Card>
      </div>
    </MainLayout>
  );
};

export default RecordingsPage;